import { Model, ObservableList, ViewModel } from '@neos/core'

/**
 * Represents CustomUIViewEntityViewParameterUI.
 */
export default class CustomUIViewEntityViewParameterUI extends Model {
  /**
   * Initializes a new instance of the CustomUIViewEntityViewParameterUI class.
   * 
   * @param item Item.
   * @param viewModel ViewModel.
   */
  constructor(item?: Record<string, unknown>, viewModel?: ViewModel<CustomUIViewEntityViewParameterUI>) {
    super({
      $new: !item,
      id: 0,
      ...item
    }, viewModel)
  }

  /**
   * Gets or sets Identifier.
   */
  id: number

  /**
   * Gets or sets Name.
   */
  name?: string | null

  /**
   * Gets or sets Value.
   */
  value?: string | null

  /**
   * Gets or sets $keyProperties.
   */
  static $keyProperties = new Set(['id'])
}